import './App.css';

import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import {  Routes, Route} from 'react-router-dom';

import ScrollToTop from './ScrollToTop'

//pages
import HomePage from './Components/Pages/HomePage'

//gaming
import ANewLeafPage from './Components/Pages/Gaming/ANewLeafPage';
import Chubbypixel from './Components/Pages/Gaming/ChubbyPixel';

//Web
import Cubity from './Components/Pages/Web/CubityPage';
import Kreativa from './Components/Pages/Web/Kreativa';

const theme = createTheme({
  typography: {
    fontFamily: [
      'Lato Black',
    ].join(','),
    h1: {
      fontSize: '2.25rem',
      '@media (max-width:600px)': {
        fontSize: '1.625rem',
      },
    },
    h2: {
      fontSize: '1.75rem',
      '@media (max-width:600px)': {
        fontSize: '1.375rem',
      },
    },
    h3: {
      fontSize: '1.125rem',
      '@media (max-width:600px)': {
        fontSize: '1.125rem',
      },
    },
    h4: {
      fontSize: '1rem',
      '@media (max-width:600px)': {
        fontSize: '1rem',
      },
    },
    h5: {
      fontSize: '0.75rem',
      '@media (max-width:600px)': {
        fontSize: '0.75rem',
      },
    }
  },
  palette: {

    primary: { main: "#000000"},
    secondary: { main: "#14213d" },
    tertiary: { main: "#fca311" },
    quaternary: { main: "#e5e5e5" },
    quinary: { main: "#ffffff" },

  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <ScrollToTop/>
      <Routes>
        <Route path="/" element={<HomePage />}></Route>
        <Route path="/gaming/anewleaf" element={<ANewLeafPage />}></Route>
        <Route path="/gaming/chubbypixel" element={<Chubbypixel />}></Route>
        <Route path="/web/cubity" element={<Cubity />}></Route>
        <Route path="/web/kreativa" element={<Kreativa />}></Route>
      </Routes>
    </ThemeProvider>
  )
}

export default App;
